import Dropdown from "components/dropdown";
import { IoMdNotificationsOutline } from "react-icons/io";

const PLACEHOLDER_ITEMS = [
  {
    title: "Welcome",
    body: "You are connected to the AlphaSniper client area.",
  },
  {
    title: "Performance",
    body: "Copy performance charts update when live data is connected.",
  },
];

export default function ClientNotificationDropdown() {
  return (
    <Dropdown
      button={
        <button
          type="button"
          className="relative flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 shadow-sm transition hover:bg-gray-50 dark:border-white/15 dark:bg-white/5 dark:text-white dark:hover:bg-white/10"
          aria-label="Notifications"
        >
          <IoMdNotificationsOutline className="h-5 w-5" />
          <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-brand-500 dark:bg-brand-400" />
        </button>
      }
      classNames="py-2 top-12 -left-[200px] w-max md:-left-[260px]"
      animation="origin-top-right transition-all duration-300 ease-in-out"
    >
      <div className="flex w-[300px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[360px]">
        <p className="text-base font-bold text-navy-700 dark:text-white">
          Notifications
        </p>
        {PLACEHOLDER_ITEMS.map((item) => (
          <div
            key={item.title}
            className="rounded-xl border border-gray-100 px-3 py-2 dark:border-white/10"
          >
            <p className="text-sm font-bold text-navy-800 dark:text-white">
              {item.title}
            </p>
            <p className="mt-0.5 text-xs text-gray-600 dark:text-gray-300">
              {item.body}
            </p>
          </div>
        ))}
      </div>
    </Dropdown>
  );
}
